import { createFileRoute } from "@tanstack/react-router";

import { BrandKitPage } from "../../features/brandkit/BrandKitPage";

export const Route = createFileRoute("/_app/brand-kit")({
  component: BrandKitPage,
});
